import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';
import Analytics from 'react-router-ga';

import { ProtectedRoute, isAuthenticated, checkUserToken, getInfoUserSession } from './main/auth/helpers';
import { getSessionStatus } from './services/services';
import { Button } from 'antd';

const HomeView = React.lazy(() => import('./main/home/home.route'));
const LoginView = React.lazy(() => import('./main/auth/auth.route'));

checkUserToken();

const Root: React.FC<any> = ({ user }) => {

  let counter = 120;

  setInterval(() => {
    // const currentdate = new Date();
    const token = localStorage.getItem('token');
    // console.log('Session SSM - ' + token, currentdate);

    if (token) {
      // console.log('Session SSM - Checking Session ... ');
      const promise = getSessionStatus(token);
      // console.log('Session SSM -', promise);
      promise.then(
        res => {
          // console.log('Session SSM -', res);
          if (res !== undefined) {
            const blocked = localStorage.getItem('session-modal');
            if (blocked !== 'blocked') {
              if (res.success && res.session_status === 2) {
                console.log('Session SSM - Entro 2');
                const modal = document.getElementById("modal-session-waiting");
                if (modal) {
                  modal.style.display = "block";
                  localStorage.setItem('session-modal', 'block');
                }
              }
  
              if (res.success && res.session_status === 1) {
                console.log('Session SSM - Entro 1');
                const modal = document.getElementById("modal-session-waiting");
                if (modal) {
                  modal.style.display = "none";
                  localStorage.setItem('session-modal', 'none');
                }

                const modal_finishing = document.getElementById("modal-session-finishing");
                if (modal_finishing) {
                  modal_finishing.style.display = "none";
                }
              }
  
              if (res.success && res.session_status === 0) {
                console.log('Session SSM - Entro 0');
                const modal = document.getElementById("modal-session-waiting");
                if (modal) {
                  modal.style.display = "none";
                  localStorage.setItem('session-modal', 'none');
                }
                const modal_finishing = document.getElementById("modal-session-finishing");
                if (modal_finishing) {
                  modal_finishing.style.display = "block";
                }
                localStorage.clear();
              }
            }
          } 
          // else {
          //   console.log('Session SSM - [NULL]');
          // }
        }
      );
    } else {
      // localStorage.removeItem('session-modal');
      // console.log('Session SSM - Without Session ... ');
    }
  }, 10000);


  setInterval(() => {
    // const currentdate = new Date();
    // console.log('Session SSM - By second ', currentdate);
    const modal_session = localStorage.getItem('session-modal');
    if (modal_session) {
      // console.log('Session SSM - By second - ', modal_session);
      if (modal_session === 'block') counter--;
      if (modal_session === 'none') counter = 120;
      if (modal_session === 'blocked') counter = 0;

      if (counter === 0) {
        // console.log('Session SSM - By second - Counter ZERO');
        localStorage.setItem('session-modal', 'blocked');
        const modal_waiting = document.getElementById("modal-session-waiting");
        if (modal_waiting) {
          modal_waiting.style.display = "none";
        }
        const modal_finishing = document.getElementById("modal-session-finishing");
        if (modal_finishing) {
          modal_finishing.style.display = "block";
        }
      }
      
      if (counter < 120) {
        // console.log('Session SSM - By second - Counter INCOMING');
        const text_waiting = document.getElementById("text-counter");
        if (text_waiting) {
          if (counter === 1) {
            text_waiting.innerHTML = "segundo";
          } else {
            text_waiting.innerHTML = "segundos";
          }
        }
        // console.log('Session SSM - By second - Counter NON ZERO');
        const span = document.getElementById('counter');
        if (span) span.innerHTML = counter.toString();
      }
    }
  }, 1000);


  const sessionClose = () => {
    window.location.href = "/login"
  }

  const sessionKeep = () => {
    getInfoUserSession();
    localStorage.removeItem('session-modal');
    const modal_waiting = document.getElementById("modal-session-waiting");
    if (modal_waiting) {
      modal_waiting.style.display = "none";
    }

    const text_waiting = document.getElementById("text-counter");
    if (text_waiting) {
      text_waiting.innerHTML = "segundos";
    }
    counter = 120;
  }



  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
        <Switch>
          <Route component={LoginView} path='/login' />
          <Route component={HomeView} path='/home' />

          {/* {ProtectedRoute('/home', HomeView, user, ['administrator'])} */}

          {/* <Redirect from={'/'} to={isAuthenticated() ? '/home' : '/login'}/> */}
        </Switch>
      </Router>
      <div id="modal-session-waiting" className="modal-session">
        <div className="modal-content-session">
          <p className="modal-close-session-title">Hola, tu sesión va a expirar en:</p>
          <p className="modal-close-session-counter"><span className="counter" id="counter">120</span><br /><span id="text-counter">segundos</span></p>
          <Button className="modal-close-session-btn-accept btn -medium -primary js-filterButton" type="primary" onClick={sessionKeep}>Continuar Sesión</Button>
        </div>
      </div>
      <div id="modal-session-finishing" className="modal-session">
        <div className="modal-content-session">
          <p className="modal-close-session-title">Tu sesión ha expirado</p>
          <Button className="modal-close-session-btn-accept btn -medium -primary js-filterButton" type="primary" onClick={sessionClose}>Aceptar</Button>
        </div>
      </div>
    </Suspense>
  );
};

function mapStateToProps (state) {
  return {
  user: state.auth.user,
};
}

export default connect(mapStateToProps)(Root);